import React from "react";
import classNames from "classnames";
import FieldData from "./FieldData";
import {get} from "../../../../../utils/dotutils";

export default class Row extends React.Component<any, any> {

    render() {
        const children = React.Children.toArray(this.props.children);
        if (children.length) {
            return <tr className="p-datatable-row">
                {children}
            </tr>
        }
        const fields = this.props.getFields({onlyVisible: true});
        const tabIndex = (new Date().getTime());
        let items = this.props.items;
        let item = this.props.item;
        let rowIdx = this.props.rowIdx;
        let selectedIdx = this.props.selectorFunction({
            item,
            items,
            selection: this.props.selection,
            props: this.props
        });
        let className = this.props.rowClassName;
        if (className instanceof Function) {
            className = className(this.props);
        }
        return (
            <tr
                key={rowIdx}
                className={classNames(className, "p-datatable-row", {"p-highlight": selectedIdx !== -1})}
                onClick={() => {
                    this.props.onSelectionChange && this.props.onSelectionChange({item, selectedIdx, rowIdx});
                }}
            >
                {fields.map((child, columnIdx) => {
                    const FieldType = child.type || FieldData;
                    return <FieldType
                        key={String(rowIdx) + "-" + String(columnIdx)}
                        {...this.props}
                        isEditing={this.props.editor.rowIndex === rowIdx && this.props.editor.columnIndex === columnIdx}
                        rowIndex={(this.props.data.navigation.rangestart || 1) + rowIdx}
                        rowKey={this.props.rowKey}
                        columnIndex={columnIdx}
                        tabIndex={String(tabIndex) + String(rowIdx) + String(columnIdx)}
                        {...child.props}
                        editor={this.props.editor}
                        data={this.props.data}
                        row={item}
                        value={get(item, child.props.field)}
                        cancelEditor={() => {
                            this.props.setEditor({rowIndex: null, columnIndex: null});
                        }}
                        setEditor={() => {
                            this.props.setEditor({rowIndex: rowIdx, columnIndex: columnIdx});
                        }}
                        isAggregation={false}
                        moveEditorNext={() => {
                            let rowIndex = this.props.editor.rowIndex;
                            let columnIndex = this.props.editor.columnIndex;
                            if (rowIndex != this.props.editor.lastRowIndex) {
                                rowIndex++;
                            }
                            if (rowIndex > items.length-1) {
                                rowIndex = 0;
                            }
                            if (columnIndex != this.props.editor.lastColumnIndex) {
                                columnIndex++;
                            }
                            if (columnIndex > fields.length-1) {
                                columnIndex = 0;
                            }
                            this.props.setEditor({rowIndex, columnIndex});
                        }}
                        moveEditorDown={() => {
                            let rowIndex = rowIdx+1;
                            if (rowIndex > items.length-1) {
                                rowIndex = 0;
                            }
                            this.props.setEditor({rowIndex, columnIndex: columnIdx})
                        }}
                        moveEditorUp={() => {
                            let rowIndex = rowIdx-1;
                            if (rowIndex < 0) {
                                rowIndex = items.length-1;
                            }
                            this.props.setEditor({rowIndex, columnIndex: columnIdx})
                        }}
                        moveEditorLeft={() => {
                            let columnIndex = columnIdx-1;
                            if (columnIndex < 0) {
                                columnIndex = fields.length-1;
                            }
                            this.props.setEditor({rowIndex: rowIdx, columnIndex})
                        }}
                        moveEditorRight={() => {
                            let columnIndex = columnIdx+1;
                            if (columnIndex > fields.length-1) {
                                columnIndex = 0;
                            }
                            this.props.setEditor({rowIndex: rowIdx, columnIndex})
                        }}
                        addItems={this.props.addItems}
                        editItems={this.props.editItems}
                        removeItems={this.props.removeItems}
                    />;
                })}
            </tr>
        );
    }
}